import { render } from "./les_detail.vue?vue&type=template&id=0672ff60&scoped=true"
import script from "./les_detail.vue?vue&type=script&lang=js"
export * from "./les_detail.vue?vue&type=script&lang=js"

import "./les_detail.vue?vue&type=style&index=0&id=0672ff60&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0672ff60"]])

export default __exports__